import { render, staticRenderFns } from "./MyLevel.vue?vue&type=template&id=f2ffc590&"
import script from "./MyLevel.vue?vue&type=script&lang=js&"
export * from "./MyLevel.vue?vue&type=script&lang=js&"
import style0 from "./MyLevel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports